import React from 'react'

import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import LiveDetail from 'components/LiveDetail'

import { StoriesStore } from 'stores/stories'
import { useStoryPageView, useStore } from 'hooks'
import { getServerSideWrapper, httpRedirect } from 'utils'

const LiveDetailPage = ({ story, videoSource, viewerCount }) => {
  useStore(StoriesStore, { current: story, currentVideoSource: videoSource, viewerCount })

  useStoryPageView(story)

  return (
    <SiteLayout hideBanner>
      <Head story={story} videoSource={videoSource} />
      <LiveDetail />
    </SiteLayout>
  )
}

export const getServerSideProps = getServerSideWrapper(async ({ params, ...ctx }) => {
  const { id } = params
  const [story, videoSource, viewerCount] = await Promise.all([
    StoriesStore().findById(id),
    StoriesStore().findVideoSource(id),
    StoriesStore().findViewerCount(id)
  ])
  // Redirect if the live post has ended, if no redirect 404
  const redirect = story.post_type_meta?.live?.redirect
  if (story.post_type_meta?.live?.status === 'post' && redirect) {
    httpRedirect(redirect, ctx)
  }

  return {
    story,
    videoSource,
    viewerCount
  }
})

export default LiveDetailPage
